import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal,
} from '@chakra-ui/react';
import * as React from 'react';

import { ChevronDownIcon } from '@/imports/ui/chakra/feather';

import {
  LIBRARY_SORT_OPTIONS,
  LibrarySortValue,
} from './sortLibraryResourceItems';

type ILibrarySortDropdownProps = {
  value: LibrarySortValue;
  onChange: (value: LibrarySortValue) => void;
};

export const LibrarySortDropdown: React.FC<ILibrarySortDropdownProps> = ({
  value,
  onChange,
}) => {
  const selectedLabel =
    LIBRARY_SORT_OPTIONS.find((option) => option.value === value)?.label ||
    LIBRARY_SORT_OPTIONS[0].label;

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="outline"
        colorScheme="gray"
        fontWeight="normal"
        borderRadius="full"
        rightIcon={<ChevronDownIcon />}
        flexShrink={0}
        whiteSpace="nowrap"
        aria-label="Sort resources"
      >
        {selectedLabel}
      </MenuButton>
      <Portal>
        <MenuList minW="220px">
          <MenuOptionGroup
            type="radio"
            value={value}
            onChange={(nextValue) => onChange(nextValue as LibrarySortValue)}
          >
            {LIBRARY_SORT_OPTIONS.map((option) => (
              <MenuItemOption key={option.value} value={option.value}>
                {option.label}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Portal>
    </Menu>
  );
};
